function tabs(){
    document.querySelectorAll('.tabs').forEach(tabs => {
        tabsInit(tabs);
    });
}

// Функция инициализации табов
function tabsInit(tabsElement){
    const links = tabsElement.querySelectorAll('.tabs__link');
    const contents = tabsElement.querySelectorAll('.tabs__content');

    links.forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        const tabId = link.getAttribute('href');
        activateTab(tabId, links, contents);
    }));

    // Инициализируем активную вкладку при загрузке страницы
    if (links.length) {
        activateTab(links[0].getAttribute('href'), links, contents);
    }

    openTabOnLink(links, contents);
    openTabOnUrl(links, contents);
}

// Функция активации вкладок
const activateTab = (tabId, links, contents) => {

    // Удаляем активный класс у всех ссылок и контента
    links.forEach(link => link.classList.remove('tabs__link_active'));
    contents.forEach(content => content.classList.remove('tabs__content_active'));

    // Находим индекс выбранного таба в массиве links
    const selectedLinkIndex = [...links].findIndex(link => link.getAttribute('href') === tabId);

    if (selectedLinkIndex !== -1) {
        const selectedLink = links[selectedLinkIndex];
        const selectedContent = contents[selectedLinkIndex];

        selectedLink.classList.add('tabs__link_active');
        selectedContent.classList.add('tabs__content_active');
    }
}

// Функция открытия таба по клику на ссылку
const openTabOnLink = (links, contents) => {
    document.querySelectorAll('.product__links-tab__item').forEach(item => {
        item.addEventListener('click', event => {
            event.preventDefault();
            const tabId = item.getAttribute('href');
            if (tabId) {
                activateTab(tabId, links, contents);
            }
        });
    });
}

// Функция открытия таба по URL
function openTabOnUrl(links, contents){
    const tabId = window.location.hash;
    if (tabId) {
        activateTab(tabId, links, contents);
    }
}

export default tabs;